import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import moment from 'moment'
import { isMobile } from 'utils'
import { withRouter } from 'react-router'

import Slider from "react-slick"

import AlertBanner from 'components/alerts/alert-banner'

import {
	openModal,
	changeTitle,
	cancelPremium
} from 'state/actions'

import {
	getCurrentAccount
} from 'state/selectors'

import {
	getPriceAndSymbol,
	getNextChargeMoment,
	getTrialEndDate,
} from 'utils'

import queryString from 'query-string'

class StatusPlan extends Component {
	state = {
		loading: true,
		planData: null,
		currency: null,
		symbol: '$',
		country: null,
		isShowingAnnual: false
	}

	componentWillMount() {
		const {
			account,
			changeTitle,
			location,
			openModal
		} = this.props

		if (location.search && !account.isPremium) {
			const queries = queryString.parse(location.search)

			if (typeof queries.openUpgrade !== 'undefined') {
				setTimeout(_ => {
					openModal('upgrade', 'account')
				}, 500)
			}
		}

		changeTitle(account.name)

		this.checkForPlanAndCurrencyData()
	}

	componentWillUpdate = nextProps => {
		if (!this.props.planAndCurrencyData) {
			this.checkForPlanAndCurrencyData(nextProps)
		}
	}

	checkForPlanAndCurrencyData = (props = this.props) => {
		if (!this.state.planData && props.planAndCurrencyData) {
			this.setState({
				...props.planAndCurrencyData
			})
		}
	}

	setPlan = plan => {
		const {
			openModal,
			account
		} = this.props

		if (parseInt(plan.plan_id) === 3) {
			return window.open('https://hassl.co/contact?reason=Enterprise', '_blank')
		}

		const accountPackageId = account.isPremium ? 2 : account.package_id

		if (parseInt(plan.plan_id) > accountPackageId) {
			openModal('upgrade', 'account')
		} else {
			let nextChargeMoment = getNextChargeMoment(account)

			if (!nextChargeMoment) {
				nextChargeMoment = moment()
			}

			openModal('confirm', 'confirm', {
				text: `On the <strong>${nextChargeMoment.format('Do of MMMM')}</strong>, you'll lose access to premium features, and all your projects will be public to anyone at <strong>${account.name}</strong>.`,
				title: "Downgrade your account?",
				buttons: [
					{
						label: 'Downgrade account',
						level: 'high',
						callback: this.cancelPremium
					}, {
						label: 'No thanks',
						level: 'low',
					}
				]
			})
		}
	}

	updateBilling = _ => {
		this.props.openModal('upgrade', 'account')
	}

	cancelPremium = _ => {
		const {
			cancelPremium,
			account,
			openModal
		} = this.props

		cancelPremium(account, _ => {
			openModal('confirm', 'confirm', {
				text: `${account.name} has been downgraded to Hassl Standard.`
			})
		})
	}

	getAlertData = _ => {
		const {
			account
		} = this.props

		const {
			planData
		} = this.state

		let alertData = {}

		const trialEndDate = getTrialEndDate(account)

		if (account.has_lifetime) {
			if (account.lifetime_amount) {
				alertData = {
					title: `You have a lifetime deal for ${account.lifetime_amount} users.`,
					body: (
						<span>
							Nice going! Subsequent any subsequent users will be billed at { account.billing_is_annual ? '$60/year' : '$6/month'}.
						</span>
					)
				}
			} else {
				alertData.title = `You're on a lifetime-free Business plan.`
				alertData.body = (
					<span>
						Ignore any pricing/billing details here. Score!
					</span>
				)
			}
		} else {
			const daysLeftOfTrial = (moment(trialEndDate).startOf('day').diff(moment().startOf('day'), 'days') + 1)

			if (daysLeftOfTrial > 0) {
				alertData.title = `There's ${daysLeftOfTrial} days left of your Hassl Business trial.`
			} else if (daysLeftOfTrial === 0) {
				alertData.title = `It's the last day of your Hassl Business trial.`
			}

			if (account.stripe_id && account.card_last_four) {
				alertData.body = `Your card ending in ${account.card_last_four} will be billed at the end of this period.`
			} else {
				alertData.body = (
					<span>
						You won't be able to access Business features at the end of this period. <a onClick={this.updateBilling} href="javascript:void(0)">Add billing details now</a>
					</span>
				)
			}

			if (isNaN(daysLeftOfTrial)) {
				alertData = null
			}
		}

		return alertData
	}

	render() {
		const {
			planData,
		} = this.state

		const {
			account,
		} = this.props

		const alertData = this.getAlertData()

		const accountPackageId = account.isPremium ? 2 : account.package_id

		const sliderProps = {
			adaptiveHeight: true,
			arrows: false,
			dots: true,
			initialSlide: (accountPackageId - 1)
		}

		const Element = isMobile() ? Slider : props => {
			return (
				<ul {...props}>
					{props.children}
				</ul>
			)
		}

		return (
			<div className="widget box plan-container">
				<h3>
					Your plan
				</h3>
				{alertData ?
					<AlertBanner
						title={alertData.title}
						body={alertData.body}
					/>
					: null}
				{planData && accountPackageId === 1 ?
					<Element
						className="package-list"
						{...sliderProps}
					>
						{planData.map((plan, index) => {
							const packageId = parseInt(plan.plan_id)

							const isActive = accountPackageId == packageId

							const buttonProps = {
								level: 'high',
								size: 'big'
							}

							if (isActive) {
								buttonProps.disabled = true
								buttonProps.label = "Current plan"
							} else if (packageId < accountPackageId) {
								buttonProps.label = "Downgrade"
								buttonProps.level = 'low'
							} else if (packageId === 3) {
								buttonProps.label = "Contact Us"
							} else {
								buttonProps.label = account.has_had_trial_already ? "Resume Hassl Business" : "Commence free trial"
							}

							const {
								price,
								symbol
							} = getPriceAndSymbol(account, account.billing_is_annual)

							const _price = symbol + price

							let className = 'package-item'

							if (isActive) {
								className += ' active'
							}

							return (
								<li
									key={index}
									className={className}
								>
									<h2>
										{plan.title}
									</h2>
									<h3>
										{_price}
										{(index && _price.length > 1) ?
											<span>
												/user
											</span>
											: null}
									</h3>
									<ul className="feature-list">
										{plan.features.map((feature, featureIndex) => {
											return (
												<li
													key={featureIndex}
													className={feature.bold ? 'bold' : null}
												>
													<Icon name="check" />
													<span>
														{feature.feature}
													</span>
												</li>
											)
										})}
									</ul>
									<Button
										{...buttonProps}
										callback={_ => { this.setPlan(plan) }}
									/>
								</li>
							)
						})}
					</Element>
					: null}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		planAndCurrencyData: state.auth.planAndCurrencyData,
		account: getCurrentAccount(state)
	}
}

export default withRouter(connect(mapStateToProps, {
	openModal,
	changeTitle,
	cancelPremium
})(StatusPlan))


// WEBPACK FOOTER //
// ./src/sections/status/status-plan.jsx